import React from 'react';

const Categories = ({ categories, selectedCategory, onCategorySelect }) => {
  const handleCategoryClick = (categoryId) => {
    onCategorySelect(categoryId);
  };

  const handleAllCategoriesClick = () => {
    onCategorySelect(null);
  };

  return (
    <div className="id-filters" id="Filters">
      <ul className="id-categories OSFillParent" style={{ position: 'relative' }}>
        <li onClick={handleAllCategoriesClick}>
          <input
            type="radio"
            name="filter-cat"
            id="all-categories"
            checked={selectedCategory === null}
            onChange={handleAllCategoriesClick}
            style={{ marginRight: '8px' }}
          />
          <label 
            htmlFor="all-categories" 
            style={{ 
              cursor: 'pointer',
              color: selectedCategory === null ? 'var(--mainColor)' : '#333',
              fontWeight: selectedCategory === null ? 'bold' : 'normal'
            }}
          >
            (Todos)
          </label>
        </li>
        {categories.map(category => (
          <li 
            key={category.id}
            onClick={() => handleCategoryClick(category.id)}
          >
            <input
              type="radio"
              name="filter-cat"
              id={`category-${category.id}`}
              checked={selectedCategory === category.id}
              onChange={() => handleCategoryClick(category.id)}
              style={{ marginRight: '8px' }}
            />
            <label 
              htmlFor={`category-${category.id}`}
              style={{ 
                cursor: 'pointer',
                color: selectedCategory === category.id ? 'var(--mainColor)' : '#333',
                fontWeight: selectedCategory === category.id ? 'bold' : 'normal'
              }}
            >
              {category.name}
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Categories;

